(function() {
  if (window.location.pathname.indexOf('/ar') !== 0) return;
  
  document.querySelectorAll('.footer a[href]').forEach(function(link) {
    var href = link.getAttribute('href');
    if (!href) return;
    if (href.indexOf('/ar/') !== -1) return;
    if (href.indexOf('mailto:') !== -1) return;
    if (href.indexOf('tel:') !== -1) return;
    if (href.indexOf('wa.me') !== -1) return;
    if (href.indexOf('google.com') !== -1) return;
    
    if (href.indexOf('giftygram.ae/') !== -1) {
      link.setAttribute('href', href.replace('giftygram.ae/', 'giftygram.ae/ar/'));
    } else if (href.charAt(0) === '/') {
      link.setAttribute('href', '/ar' + href);
    }
  });
})();